import { observable, action, } from 'mobx';
import { Injectable } from '@angular/core';
import { DataService } from '../services/data.service';
import { pushToArray } from '../services/mapping.service';

@Injectable()
export class ConfigStore {
    @observable data: any[] = [];
    @observable process: boolean = false;
    @observable loading: boolean = true;
    @observable empty: boolean = false;
    @observable term: any;
    
    constructor(private ds: DataService) { }

    @action
    async fetchTerm() {
        const doc = await this.ds.termRef(ref => ref.where('isCurrent', '==', true).limit(1)).get().toPromise();
        if (doc.empty) return null;
        const list = pushToArray(doc);
        this.term = list[0];
        return this.term;
    }
}
